import React from 'react';
import './Facility.css';

const Facility = () => {
  const facilities = [
    {
      id: 'library',
      title: 'LIBRARY',
      description: 'Libraries provide the crucial role in promoting education, research, personality development, ethics and other important values. A society cannot flourish without proper education and the primary requirement of the education system is the knowledge available in the books.',
      image: 'library.jpeg',
      imageAlt: 'Library',
      bgColor: 'dark-blue',
      layout: 'text-left'
    },
    {
      id: 'science-lab',
      title: 'SCIENCE LAB',
      description: 'What is it science lab? laboratory, Place where scientific research and development is conducted and analyses performed, in contrast with the field or factory. Most laboratories are characterized by controlled uniformity of conditions (constant temperature, humidity, cleanliness).',
      image: 'science-lab.jpeg',
      imageAlt: 'Science Lab',
      bgColor: 'orange',
      layout: 'image-left'
    },
    {
      id: 'math-lab',
      title: 'MATHEMATICS LAB',
      description: 'A hands-on space where students explore mathematical concepts using manipulatives, puzzles and models to build strong reasoning and problem-solving skills.',
      image: 'math-lab.jpeg',
      imageAlt: 'Mathematics Lab',
      bgColor: 'dark-blue',
      layout: 'text-left'
    },
    {
      id: 'sports',
      title: 'SPORTS AND GAMES',
      description: 'Games and sports are very similar: a game is a physical or mental activity or contest that has rules and that people do for pleasure. A sport is a contest or game in which people do certain physical activities according to a specific set of rules and compete against each other. The difference is subtle.',
      image: 'sports.jpeg',
      imageAlt: 'Sports and Games',
      bgColor: 'green',
      layout: 'text-left'
    },
    {
      id: 'computer-lab',
      title: 'COMPUTER LAB',
      description: 'computer lab is a space where computer services are provided to a defined community. These are typically public libraries and academic institutions. Generally, users must follow a certain user policy to retain access to the computers.',
      image: 'computer-lab.jpeg',
      imageAlt: 'Computer Lab',
      bgColor: 'dark-blue',
      layout: 'text-left'
    },
    {
      id: 'classroom',
      title: 'CLASS ROOM',
      description: 'A classroom definition can be understood as a room in a school where lessons happen. Teachers go here to mark work, plan lessons and teach their students. All children who attend school will go to the classroom on a daily basis to learn and meet with their fellow students and teachers..',
      image: 'classroom.jpeg',
      imageAlt: 'Classroom',
      bgColor: 'orange',
      layout: 'image-left'
    },
    {
      id: 'restroom',
      title: 'RESTROOM',
      description: 'A restroom is a public bathroom or lavatory. You might stop at a fast food restaurant during a long drive to use the restroom and buy some fries. You\'ll find restrooms in restaurants, libraries, schools, highway rest areas, and shopping malls, among other places.',
      image: 'restroom.jpeg',
      imageAlt: 'Restroom',
      bgColor: 'dark-blue',
      layout: 'text-left'
    }
  ];

  return (
    <main className="facility-page">
      <div className="facility-container">
        <div className="facility-header">
          <h1 className="facility-main-title">OUR FACILITIES</h1>
          <p className="facility-intro">
            An effective school facility is responsive to the changing programs of educational delivery, 
            and at a minimum should provide a physical environment that is comfortable, safe, secure, 
            accessible, well illuminated, well ventilated, and aesthetically pleasing.
          </p>
        </div>

        <div className="facilities-grid">
          {facilities.map((facility) => (
            <div 
              key={facility.id} 
              className={`facility-block ${facility.layout} ${facility.bgColor}`}
            >
              {facility.layout === 'text-left' ? (
                <>
                  <div className="facility-text-panel">
                    <h2 className="facility-title">{facility.title}</h2>
                    <p className="facility-description">{facility.description}</p>
                  </div>
                  <div className="facility-image-panel">
                    <img 
                      src={`${process.env.PUBLIC_URL}/images/${facility.image}`}
                      alt={facility.imageAlt}
                      className="facility-image"
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="facility-image-panel">
                    <img 
                      src={`${process.env.PUBLIC_URL}/images/${facility.image}`}
                      alt={facility.imageAlt}
                      className="facility-image"
                    />
                  </div>
                  <div className="facility-text-panel">
                    <h2 className="facility-title">{facility.title}</h2>
                    <p className="facility-description">{facility.description}</p>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Facility;

